import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './WeatherReports.scss'
import {toggleModal} from "../store/actions/toggleModalActions";
import ExternalModal from "./_common/ExternalModal";
import WeatherStations from "./WeatherStations"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import {
    downloadReport,
    getWeatherDataReports,
    getWeatherDataReportsSuccess,
    setWeatherDataReportsFilters
} from "../store/actions/weatherDataReportsActions";
import Spinner from "./_common/Spinner";
import WeatherReportsChart from "./WeatherReportsChart";
import WeatherStationPdfReportModal from "./WeatherStationPdfReportModal";



const selector = state => {
    const { language,  modalState, weatherDataReports, weatherStations } = state;
    return {
        t: language.translator,
        modalState: modalState,
        pending: weatherDataReports.pending,
        weatherDataReports: weatherDataReports.weatherDataReports,
        filters: weatherDataReports.filters,
        weatherStations: weatherStations.weatherStations
    }
};

const WeatherReports = () => {
    const { t, modalState, weatherDataReports, pending, filters } = useSelector(selector)
    const [currentFilter, setCurrentFilter] = useState(null)
    const [showNumberOfDaysFilter, setShowNumberOfDaysFilter] = useState(false);
    const [showMeasurementsPeriodFilter, setShowMeasurementsPeriodFilter] = useState(false);
    const [selectedStation, setSelectedStation] = useState(null)
    const [selectedMeasurementFilter, setSelectedMeasurementFilter] = useState(null)
    const dispatch = useDispatch();
    // const [stationModal, setStationModal] = useState({isOpen: false})


    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const expand = (filter) => {
        setCurrentFilter(filter)
    }

    const closeFilter = () => {
        setCurrentFilter(null)
    }

    useEffect(()=> {
        dispatch(getWeatherDataReportsSuccess(''))
       dispatch(setWeatherDataReportsFilters({dateFrom: '', dateTo: '', numberOfDaysInPast: '', measurementsPeriodAggregation: '', weatherStationId: ''}))
       setSelectedStation(null)
    },[])

    useEffect(() => {
        setCurrentFilter('')
    },[filters.dateTo])

    useEffect(() => {
        setCurrentFilter('')
    },[filters.dateFrom])

    const numberOfDays = [
        {label: t.gettext('last 24 hours'), value: 1},
        {label: t.gettext('last week'), value: 7},
        {label: t.gettext('last month'), value: 30},
    ]

    const measurePeriod = [
        // {label: t.gettext('Raw'), value: 'RAW'},
        {label: t.gettext('30 minute'), value: 'MIN_30_PERIOD'},
        {label: t.gettext('Hour'), value: 'HOUR_1_PERIOD'},
        {label: t.gettext('Day'), value: 'DAY_1_PERIOD'},
        {label: t.gettext('Month'), value: 'MONTH'},
    ]
    // const toggleStationModal = () => {
    //     setStationModal({isOpen: !stationModal.isOpen})
    // }
    const selectDate = (date, filter) => {
        if(filters.weatherStationId) {
            dispatch(setWeatherDataReportsFilters({...filters, [filter]: date }))
            dispatch(getWeatherDataReports({...filters, [filter]: date }))
        }
        closeFilter()
    }

    const selectStation = (station) => {
        dispatch(setWeatherDataReportsFilters({...filters, weatherStationId: station.id}))
        dispatch(getWeatherDataReports({...filters, weatherStationId: station.id }))
        setSelectedStation(station)
    }



    return (
        <div className="weatherReports">
            <div className='weatherReportsHeader'>
                <div><span>{t.gettext('Weather data reports')}</span> {selectedStation ? <span className='stationName'>{selectedStation.name}</span> : ''}</div>
                <div className="selectStationBtn" onClick={() => dispatch(toggleModal(true, 'Select Station'))}>
                    {t.gettext('Select station')}
                </div>
            </div>
            <div className="weatherReportsFilters">
                <div className="filterContainer" onClick={() => expand('dateFrom')}>
                    <span className='filterType'>{t.gettext('Date from')}:</span>
                    <span className="selectedFilter">&nbsp;{filters.dateFrom ? filters.dateFrom.toLocaleDateString() : ''}</span>
                        {currentFilter === 'dateFrom' &&
                            <DatePicker
                                // className="addModalInput dateInput"
                                dateFormat="dd/MM/yyyy"
                                selected={filters.dateFrom ? filters.dateFrom : null}
                                inline
                                onChange={(date) => selectDate(date, 'dateFrom')}
                                disabled={!filters.weatherStationId}
                                // onChange={() => loadFields(selectedFilters)}
                            />
                        }
                </div>
                <div className="filterContainer" onClick={() => expand('dateTo')}>
                    <span className='filterType'>{t.gettext('Date to')}:</span>
                    <span className="selectedFilter">&nbsp;{filters.dateTo ? filters.dateTo.toLocaleDateString() : ''}</span>
                    {currentFilter === 'dateTo' &&
                        <DatePicker
                            // className="addModalInput dateInput"
                            dateFormat="dd/MM/yyyy"
                            selected={filters.dateTo ? filters.dateTo : null}
                            inline
                            onChange={(date) => selectDate(date, 'dateTo')}
                            // onChange={() => loadFields(selectedFilters)}
                        />
                    }
                </div>
                <div
                    className='filterTypeFormSelect'
                    onClick={() => setShowNumberOfDaysFilter(!showNumberOfDaysFilter)}
                >
                    <div className='filterTypeFormSelectText'>
                        {filters.numberOfDaysInPast ? numberOfDays.find(x => x.value === filters.numberOfDaysInPast).label : t.gettext('Number of days')}
                    </div>
                    <i className="material-icons dropDownIcon">
                        {showNumberOfDaysFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                    </i>
                    {showNumberOfDaysFilter &&
                        <div className='filterTypeFormSelectOptions'>
                            {numberOfDays.map((item, index) => (
                                <div
                                    className='filterTypeFormSelectOption'
                                    key={index}
                                    onClick={() => {
                                        if(filters.weatherStationId) {
                                            dispatch(setWeatherDataReportsFilters({...filters, numberOfDaysInPast: item.value }))
                                            dispatch(getWeatherDataReports({...filters, numberOfDaysInPast: item.value }))
                                        }
                                    }}
                                >
                                    {item.label}
                                </div>
                            ))}
                        </div>
                    }
                </div>
                <div
                    className='filterTypeFormSelect'
                    onClick={() => setShowMeasurementsPeriodFilter(!showMeasurementsPeriodFilter)}
                >
                    <div className='filterTypeFormSelectText'>
                        {filters.measurementsPeriodAggregation ? measurePeriod.find(x => x.value === filters.measurementsPeriodAggregation).label : t.gettext('Measurements period')}
                    </div>
                    <i className="material-icons dropDownIcon">
                        {showMeasurementsPeriodFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                    </i>
                    {showMeasurementsPeriodFilter &&
                        <div className='filterTypeFormSelectOptions'>
                            {measurePeriod.map((item, index) => (
                                <div
                                    className='filterTypeFormSelectOption'
                                    key={index}
                                    onClick={() => {if(filters.weatherStationId) {
                                        dispatch(setWeatherDataReportsFilters({...filters, measurementsPeriodAggregation: item.value }))
                                        dispatch(getWeatherDataReports({...filters, measurementsPeriodAggregation: item.value }))
                                        setSelectedMeasurementFilter(item.value)
                                    }
                                    }}
                                >
                                    {item.label}
                                </div>
                            ))}
                        </div>
                    }
                </div>
                {weatherDataReports && (
                    <div className="reportBtnContainer">
                        <div className="downloadReportBtn" onClick={() => dispatch(downloadReport(filters))}>
                            {t.gettext('Download Report')}
                        </div>
                        <div className="downloadReportBtn"
                             onClick={() => dispatch(toggleModal(true, 'Chart'))}
                        >
                            {t.gettext('Chart')}
                        </div>
                        <button
                            type="button"
                            className="downloadReportBtn"
                            disabled={!selectedStation}
                            onClick={() => dispatch(toggleModal(true, 'PDF Report'))}
                        >
                            {t.gettext('Get PDF report')}
                        </button>
                    </div>
                )}
            </div>
            <div className="weatherReportsBox">
                {pending &&
                    <div className='page'>
                        <Spinner size={300}/>
                    </div>
                }
                { (!weatherDataReports || weatherDataReports.length === 0)
                    ?  <div className='selectInfo'>{t.gettext('Please select a weather station')}</div>
                    :
                    <Fragment>
                    <ul className="reportsList">
                        <li className='reportsListHeader'>
                            {weatherDataReports && weatherDataReports.headers && weatherDataReports.headers.map((el, index) => (
                                <div className='subHeader'  >
                                    <div className='listHeaderCell'  key={index}>
                                        {el.mergedHeader}
                                    </div>
                                    <div className='listHeaderCell subHeaderCell'>
                                        {el.subHeaders.map((headers, index) => (
                                            <div className='subHeaderDiv'  style={headers === 'Date/Hour' ? {width: "180px"} : {width: "90px"}} >
                                                {headers}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </li>
                        {weatherDataReports && weatherDataReports.values.length > 0 && weatherDataReports.values.map((val) => (
                            <li className="reportsListItem">
                                {val.map((el, index) => (
                                    <div className="listItemCell" style={index === 0 ? {width: '180px'} : {width: "90px"}}>
                                        {index === 0 ? el.split('T').join(' ') : el}
                                    </div>
                                ))}
                            </li>
                        ))}
                        <li className="reportsListItem">
                            <div className="listItemCell">
                                {t.gettext('Total') + ' ' + Object.keys(weatherDataReports.totals)[0]+ ': ' + Object.values(weatherDataReports.totals)[0]}
                            </div>
                            <div className="listItemCell">
                                {t.gettext('Total') + ' ' + Object.keys(weatherDataReports.totals)[1]+ ': ' +  Object.values(weatherDataReports.totals)[1]}
                            </div>
                        </li>
                    </ul>

                    <ul className="reportsList">


                    </ul>
                        {/*{totals.map()}*/}
                    </Fragment>
                }


            </div>
            {modalState.flag && modalState.modal === 'Select Station' &&
                <ExternalModal
                    closeMethod={closeModal}
                    title={'Weather Stations'}
                >
                    <WeatherStations
                        stationPicker
                        selectStationPicker={selectStation}
                        toggleStationPicker={closeModal}
                    />
                </ExternalModal>
            }
            {modalState.flag && modalState.modal === 'Chart' && (
                <ExternalModal
                    closeMethod={closeModal}
                    title={t.gettext('Chart')}
                >
                    <WeatherReportsChart
                        measurementPeriod={selectedMeasurementFilter}
                        data={weatherDataReports}
                    />
                </ExternalModal>
            )}
            {modalState.flag && modalState.modal === 'PDF Report' && (
                <ExternalModal
                    closeMethod={closeModal}
                    title={t.gettext('PDF weather station report')}
                >
                    <WeatherStationPdfReportModal
                        filters={filters}
                        closeMethod={closeModal}
                        t={t}
                    />
                </ExternalModal>
            )}
        </div>
    );
};

export default WeatherReports
